import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const popup = {
  fetchPopups: lazyModuleMethod(() => import('./fetchPopups'), 'default'),
  fetchPopup: lazyModuleMethod(() => import('./fetchPopup'), 'default'),
  updatePopup: lazyModuleMethod(() => import('./updatePopup'), 'default'),
  createPopup: lazyModuleMethod(() => import('./createPopup'), 'default'),
  deletePopup: lazyModuleMethod(() => import('./deletePopup'), 'default'),
}
